import tokens from "../../../design-system/tokens";
import { ShellContent } from "../../shell/Shell.jsx";
import Button from "../../../design-system/components/Button/Button.jsx";
import { ROUTES } from "../../../routes.js";
import { MODELS, useModel } from "../../../api";
import { styles } from "../../not-found/notFoundPage.css.ts";

const NotAuthorizedPage = () => {
  const currentUser = useModel(MODELS.ME);
  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <div className={styles.container}>
        <p className={styles.text}>Hier geht es nicht weiter!</p>
        {currentUser ? (
          <Button width="fit" to={ROUTES.lernreisenOverview.getUrl()}>
            Hier kommst du zurück zur Übersicht deiner Lernreisen!
          </Button>
        ) : (
          <Button width="fit" to={ROUTES.login.getUrl()}>
            Zurück zur Startseite
          </Button>
        )}
      </div>
    </ShellContent>
  );
};

export default NotAuthorizedPage;
